import { theme } from '@refract-ui/core';
import { DefaultTheme } from 'styled-components';
import { refract, gfx } from '../shared';

const cgrTheme = {
  name: 'cgr',
  ...gfx,
  ...theme({
    ...refract,
    colors: { gray: '#333333' },
    themeColors: ({ defaults, theme }) => ({
      ...defaults,
      bg: theme?.colors?.black,
      fg: theme?.colors?.white,
      primary: theme?.colors?.white,
      secondary: theme?.colors?.gray,
      danger: theme?.colors?.red,
      warning: theme?.colors?.yellow
    })
  })
} as DefaultTheme;

export default cgrTheme;
